import uniq from 'lodash/uniq';

export const usedFunnelMapCrmOrgIds = (funnelMap: FunnelMap) => {
  const funnelMapFunnelCrmOrgIds = Object.values(funnelMap.funnelsData).map(
    (funnel) => funnel.crmOrgId,
  );
  const funnelMapDataCrmOrgIds = Object.values(funnelMap.metadataElements).map(
    (metadataElement) => metadataElement.crmOrgId,
  );
  return uniq([...funnelMapFunnelCrmOrgIds, ...funnelMapDataCrmOrgIds])
    .filter(Boolean)
    .sort();
};
